import { useTranslation } from 'react-i18next';
import type { MenuProps } from 'antd';
import { Button, Dropdown, Flex } from 'antd';
import { StarOutlined } from '@ant-design/icons';
import type { MenuInfo } from 'rc-menu/lib/interface';
import { useClearFavorite } from 'api/favorites/use-clear-favorite';
import { useGetFavorites } from 'api/favorites/use-get-favorites';
import type { TFavoriteColors } from 'api/swagger';
import { favoriteColorMapping } from 'types/favorites';
import { FavoriteColorCircle } from '../favorite-color-circle';

export const ClearFavoriteButton = () => {
  const { t } = useTranslation();
  const { data, isLoading } = useGetFavorites();
  const { mutate: clearFavorite } = useClearFavorite();

  const favoriteCounts = data?.favoriteCounts;

  if (!favoriteCounts) return null;

  const clearColor = (e: MenuInfo) => {
    if (e.key === 'clear_all') {
      clearFavorite({});
    } else {
      clearFavorite({ color: e.key as TFavoriteColors });
    }
  };

  const entries = Object.entries(favoriteCounts || {}) as [TFavoriteColors, number][];

  const items: MenuProps['items'] = [];

  entries.forEach(([color, count]) => {
    if (count > 0) {
      items.push({
        key: color,
        label: (
          <Flex align='center' gap={8}>
            <FavoriteColorCircle backgroundColor={favoriteColorMapping[color]} />
            {`${t('favorite:clear_color')} (${count})`}
          </Flex>
        ),
      });
    }
  });

  items.push({
    key: 'clear_all',
    label: <Flex justify='center'> {t('favorite:clear_all')}</Flex>,
  });

  return (
    <Flex gap='small' align='center' justify='flex-end'>
      <Dropdown menu={{ items, onClick: clearColor }} trigger={['click']}>
        <Button icon={<StarOutlined />} disabled={isLoading} style={{ border: 'none' }} ghost />
      </Dropdown>
    </Flex>
  );
};
